import { render, staticRenderFns } from "./ListRecepcionists.vue?vue&type=template&id=89dcc4e4&scoped=true&"
import script from "./ListRecepcionists.vue?vue&type=script&lang=ts&"
export * from "./ListRecepcionists.vue?vue&type=script&lang=ts&"
import style0 from "./ListRecepcionists.vue?vue&type=style&index=0&id=89dcc4e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dcc4e4",
  null
  
)

export default component.exports